import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-terminal",
  "use": "icon-terminal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-terminal\"><path d=\"M960 80H64c-17.6 0-32 14.4-32 32v640c0 17.6 14.4 32 32 32h896c17.6 0 32-14.4 32-32v-640c0-17.6-14.4-32-32-32z m-32 640H96v-576h832v576zM795.84 880H228.16c-17.6 0-32 14.4-32 32s14.4 32 32 32h567.36c17.6 0 32-14.4 32-32s-14.08-32-31.68-32z\" p-id=\"5823\" /><path d=\"M763.2 509.76l79.36-33.92-192.32-79.36 79.04 192.32z\" p-id=\"5824\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/terminal.svg
// module id = gEzl
// module chunks = 12